import { css } from "emotion";
import { Component } from "preact";
import IconArrowDown from "../../assets/images/icon-arrow-down.svg";
import YourOrder from "../../components/YourOrder";
import AssignSummary from "./AssignSummary";
const orderSummaryStyle = css({
  backgroundColor: "#f9f9fa",
  display: "flex",
  paddingTop: 10,
  paddingBottom: 10,
  alignItems: "center",
  cursor: "pointer"
});

const hybridSummaryStyle = css({
  boxShadow: "0 1px 4px 0 rgba(9, 30, 66, 0.13)",
  "@media (max-width: 600px)": {
    display: "none"
  }
});

export default class HybridSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false
    };
  }

  render({ ticketsGroupedByType, token }) {
    const { expanded } = this.state;
    return (
      <div className={hybridSummaryStyle}>
        {!token ? (
          <div
            className={orderSummaryStyle}
            onClick={() => this.setState({ expanded: !expanded })}
          >
            <h2 style={{ flexGrow: 1, marginLeft: 16, marginBottom: 0 }}>
              View your order
            </h2>
            <img
              src={IconArrowDown}
              style={{
                width: 16,
                height: 24,
                marginRight: 16,
                transform: `rotate(${expanded ? 180 : 0}deg)`
              }}
            />{" "}
          </div>
        ) : null}
        {expanded ? (
          <YourOrder allowDiscountsAdd={false} isGlobal={false} />
        ) : null}
        <AssignSummary ticketsGroupedByType={ticketsGroupedByType} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./routes/conferences/HybridSummary.js